import { render, staticRenderFns } from "./workLocuskf.vue?vue&type=template&id=24ed8cf4&scoped=true"
import script from "./workLocuskf.vue?vue&type=script&lang=js"
export * from "./workLocuskf.vue?vue&type=script&lang=js"
import style0 from "./workLocuskf.vue?vue&type=style&index=0&id=24ed8cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed8cf4",
  null
  
)

export default component.exports